import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../../../../components/Button';
import SearchHeader from '../../../../components/SearchHeader';
import AdminTable from '../../components/AdminTable';
import BatchEditMenu from '../../components/BatchEditMenu';
import TagList from '../../components/AdminTable/TagList';
import LoadMask from '../../../../components/LoadMask';

import AddPlatformUserModal from './AddPlatformUserModal';
import EditPlatformUserModal from './EditPlatformUserModal';
import BatchEditPermissionsModal from './BatchEditPermissionsModal';

import { fetchPlatformUsers } from '../../../../redux/admin-platform-users';
import { fetchCompanies } from '../../../../redux/admin-companies';
import { getPlatformUsersUI } from '../../../../redux/selectors';
import { USER_TYPES } from '../../shared/static-options';

const tableColumnNames = {
  NAME: 'name',
  EMAIL: 'email',
  COMPANY_NAME: 'companyName',
  IS_CUSTOMER_SERVICE: 'isCustomerService',
  ROLES: 'roles',
  EDIT: 'edit',
};

class AdminPlatformUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addUserModal: {
        visible: false,
      },
      editUserModal: {
        visible: false,
        userData: null,
      },
      batchEditPermissionsModal: {
        visible: false,
        userDataList: null,
      },
      tableHeaders: [
        {
          name: tableColumnNames.NAME,
          label: 'Nome',
          boldPrimary: true,
        },
        {
          name: tableColumnNames.EMAIL,
          label: 'E-mail',
        },
        {
          name: tableColumnNames.COMPANY_NAME,
          label: 'Empresa',
        },
        {
          name: tableColumnNames.IS_CUSTOMER_SERVICE,
          label: 'SAC',
        },
        {
          name: tableColumnNames.ROLES,
          label: 'Permissões',
        },
      ],
      tableActions: [
        {
          name: tableColumnNames.EDIT,
          label: 'Editar',
          iconName: 'mode_edit',
          actionFn: this._toggleEditPlatformUserModal,
        },
      ],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchPlatformUsers());
    dispatch(fetchCompanies());
  }

  _onSearch = (searchValue) => {
    const { dispatch } = this.props;
    dispatch(fetchPlatformUsers(searchValue));
  }

  _toggleAddPlatformUserModal = () => {
    this.setState({
      addUserModal: {
        visible: !this.state.addUserModal.visible,
      },
    });
  }

  _toggleEditPlatformUserModal = (userData) => {
    this.setState({
      editUserModal: {
        visible: !this.state.editUserModal.visible,
        userData: userData || null,
      },
    });
  }

  _toggleEditPermissionsModal = (userDataList) => {
    this.setState({
      batchEditPermissionsModal: {
        visible: !this.state.batchEditPermissionsModal.visible,
        userDataList: userDataList || null,
      },
    });
  }

  _renderBatchEdit = (selectedRows) => {
    if (!selectedRows) return null;

    return (
      <BatchEditMenu
        selectedCount={selectedRows.length}
        entityName="usuários"
      >
        <Button
          skin="primary"
          text="ALTERAR EMPRESA"
          onClick={() => { }}
        />
        <Button
          skin="primary"
          text="EDITAR PERMISSÕES"
          onClick={() => this._toggleEditPermissionsModal(selectedRows)}
        />
        <Button
          skin="danger"
          text="REMOVER SELECIONADOS"
          onClick={() => { }}
        />
      </BatchEditMenu>
    );
  }

  _onRenderCell = (column, value, row) => {
    if (column === tableColumnNames.IS_CUSTOMER_SERVICE) {
      if (row.userType === USER_TYPES.CUSTOMER_SERVICE_USER) {
        return 'Sim';
      }

      return '-';
    }

    if (column === tableColumnNames.ROLES) {
      return <TagList tagData={value} />;
    }
    return value;
  }

  render() {
    const {
      addUserModal,
      editUserModal,
      batchEditPermissionsModal,
      permissions,
      tableHeaders,
      tableActions,
    } = this.state;

    const { ui, platformUsers, companies } = this.props;

    return (
      <div>
        <SearchHeader
          onSearch={this._onSearch}
          right={() => (
            <Button
              skin="primary"
              text="ADICIONAR USUÁRIO"
              onClick={this._toggleAddPlatformUserModal}
            />
          )}
        />
        <AdminTable
          errorMessage={ui.error}
          headers={tableHeaders}
          data={platformUsers}
          actions={tableActions}
          renderBatchEdit={this._renderBatchEdit}
          onRenderCell={this._onRenderCell}
        />
        {
          addUserModal.visible &&
          <AddPlatformUserModal
            companies={companies}
            permissions={permissions}
            onDismiss={this._toggleAddPlatformUserModal}
          />
        }
        {
          editUserModal.visible &&
          <EditPlatformUserModal
            companies={companies}
            permissions={permissions}
            userData={editUserModal.userData}
            onDismiss={this._toggleEditPlatformUserModal}
          />
        }
        {
          batchEditPermissionsModal.visible &&
          <BatchEditPermissionsModal
            companies={companies}
            permissions={permissions}
            userDataList={batchEditPermissionsModal.userDataList}
            onDismiss={this._toggleEditPermissionsModal}
            onEditCompleted={this._}
          />
        }
        {
          ui.isFetching &&
          <LoadMask text="Carregando..." />
        }
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    ui: getPlatformUsersUI(state),
    platformUsers: state.adminPlatformUsers.platformUsers.data,
    companies: state.adminCompanies.companies.data,
  };
}

export default connect(mapStateToProps)(AdminPlatformUsers);
